
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M21.999 8.362v1.062a.531.531 0 01-.531.531h-2.125v2.125a.531.531 0 01-.53.53H17.75a.531.531 0 01-.531-.53V9.955h-2.124a.531.531 0 01-.532-.53V8.361a.531.531 0 01.532-.531h2.124V5.707a.531.531 0 01.531-.532h1.062a.531.531 0 01.531.532V7.83h2.125a.531.531 0 01.53.531z","fill":"#007EC1"}}),_c('path',{attrs:{"d":"M8.19 9.424a4.249 4.249 0 100-8.497 4.249 4.249 0 000 8.497zm2.974 1.062h-.554a5.778 5.778 0 01-4.84 0h-.554a4.462 4.462 0 00-4.461 4.462v1.38a1.593 1.593 0 001.593 1.594h11.684a1.593 1.593 0 001.594-1.594v-1.38a4.462 4.462 0 00-4.462-4.462z","fill":"#007EC1"}})])
          )
        }
      }
    